import React from "react";
import styled from "styled-components";
import introImg from "../imgs/_intro.jpeg";
import "./Intro.scss";

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 350px auto;
  grid-template-rows: 1fr;
  margin-top: 10px;
  @media (max-width: 991px){
    grid-template-columns: 1fr;
    grid-template-rows: auto auto;
  }
`;

const Orlando = styled.div`
  grid-column-start: 1;
  grid-column-end: 2;
  background-image: url(${introImg});
  background-repeat: no-repeat;
  background-size: contain;
  height: 420px;
  @media (max-width: 991px){
    grid-column-start: 1;
    grid-column-end: 2;
    grid-row-start: 2;
    grid-row-end: 3;
    background-size: cover;
  }
`;

const Info = styled.div`
  grid-column-start: 2;
  grid-column-end: 3;
  padding: 20px;
  @media (max-width: 991px){
    grid-column-start: 1;
    grid-column-end: 2;
    grid-row-start: 1;
    grid-row-end: 2;
  }
`;

class Intro extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentDidMount() {}

  render() {
    return (
      <Wrapper>
        <Orlando />
        <Info>
          <h1>Orlando Machado Neto</h1>
          <p>
            Orlando Neto holds a 5th degree black belt under Vinicius Campelo and Octavio Couto.
            When he was four years old, he was introduced to this martial art and since then, he has been implementing the
            ways of brazilian jiu-jitsu in every aspect of his life.
            He was formed at akxebjj academy in Rio de Janeiro, Brazil.
          </p>
          <br />
          <p>
          
            Since he earned his black belt, Orlando Neto has had a 20 years teaching experience
            as one of the first black belt masters to spread brazilian jiu-jitsu in Europe and
            other parts of the world.
            <br/>
            
            Forming a big amount of recognized champions and also guiding many martial artists, as well as hobby
            practitioners like students, musicians, lawyers, doctors among others.
          </p>
        </Info>
      </Wrapper>
    );
  }
}

export default Intro;
